import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { EvictionTenantsSectionComponent } from './forms/eviction-tenants-section.component';
import { EvictionPropertyDetailsComponent } from './forms/eviction-property-details.component';
import { EvictionPropertySectionComponent } from './forms/eviction-property-section.component';
import { ClaimsSectionComponent } from './forms/claims-section.component';
import { LeaseTermsSectionComponent } from './forms/lease-terms-section.component';
import { InternalSectionComponent } from './forms/internal-section.component';
import { OtherSectionComponent } from './forms/other-section.component';
import { OrganizationFormComponent } from './forms/organization-form.component';
import { UserDetailsFormComponent } from './forms/user-form.component';
import { CreateEvictionComponent } from './create-eviction/create-eviction.component';
import { EvictionIntakeShellComponent } from './create-eviction/eviction-intake-shell.component';
import { EvictionWizardV2Component } from './create-eviction/eviction-wizard-v2.component';
import { IntakeLayoutRendererComponent, IntakeWizardComponent, PlaintiffNameFieldComponent } from '@ee/common/intake-layout';
import { WorkflowFormComponent } from './forms/workflow-form.component';
import { EvictionDocumentationComponent } from './forms/eviction-documentation.component';
import { MatLineModule } from '@angular/material/core';
import { EePipesModule } from '@ee/common/pipes';
import { EeDirectivesModule } from '@ee/common/directives';
import { LoadingModule } from '@ee/common/loading';
import { AddressAutocompleteModule } from '@ee/common/address-autocomplete';
import { ClientSelectionModule } from '@ee/common/client-selection';
import { MatRadioModule } from '@angular/material/radio';
import { CustomFieldModule } from '@ee/common/custom-field';
import { MatListModule } from '@angular/material/list';
import { PastDueRentHistoryComponent } from './forms/past-due-rent-history.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { LayoutModule } from '@angular/cdk/layout';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { BillableItemEditorModule } from '@ee/common/billable-item-editor';
import { DocumentTemplateSelectorModule } from '@ee/common/document-template-selector';
import { ExpansionPanelModule } from '@ee/common/expansion-panel';
import { UploaderModule } from '@ee/common/uploader';
import { WorkflowStepModule } from '@ee/common/workflow-step';
import { IntakeEvictionFormService } from './services/intake-eviction-form.service';
import { TippyDirective } from '@ngneat/helipopper';
import { IntakeDocViewModule } from '@ee/common/intake-doc-view';
import { CourthouseSelectorComponent } from '@ee/common/courthouse-selector';

@NgModule({
  imports: [
    IntakeWizardComponent,
    IntakeLayoutRendererComponent,
    PlaintiffNameFieldComponent,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSnackBarModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatIconModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatStepperModule,
    EePipesModule,
    EeDirectivesModule,
    LoadingModule,
    AddressAutocompleteModule,
    ClientSelectionModule,
    MatRadioModule,
    CustomFieldModule,
    MatListModule,
    MatExpansionModule,
    LayoutModule,
    BillableItemEditorModule,
    NgxMaskDirective,
    DocumentTemplateSelectorModule,
    ExpansionPanelModule,
    MatLineModule,
    UploaderModule,
    WorkflowStepModule,
    TippyDirective,
    IntakeDocViewModule,
    CourthouseSelectorComponent
  ],
  declarations: [
    EvictionIntakeShellComponent,
    EvictionWizardV2Component,
    EvictionDocumentationComponent,
    EvictionPropertyDetailsComponent,
    EvictionTenantsSectionComponent,
    PastDueRentHistoryComponent,
    OrganizationFormComponent,
    UserDetailsFormComponent,
    CreateEvictionComponent,
    WorkflowFormComponent,
    EvictionPropertySectionComponent,
    LeaseTermsSectionComponent,
    ClaimsSectionComponent,
    InternalSectionComponent,
    OtherSectionComponent
  ],
  exports: [
    // The shell wraps `ee-create-eviction` rather than replacing it, so a consumer that already imports
    // this module gets the v1/v2 switch without changing its own imports.
    EvictionIntakeShellComponent,
    CreateEvictionComponent,
    PastDueRentHistoryComponent,
    EvictionDocumentationComponent,
    EvictionPropertyDetailsComponent,
    EvictionTenantsSectionComponent,
    OrganizationFormComponent,
    UserDetailsFormComponent,
    OrganizationFormComponent,
    WorkflowFormComponent,
    EvictionPropertySectionComponent,
    LeaseTermsSectionComponent,
    ClaimsSectionComponent,
    InternalSectionComponent,
    OtherSectionComponent
  ],
  providers: [IntakeEvictionFormService, provideEnvironmentNgxMask()]
})
export class EvictionIntakeModule {
  public static forRoot(environment: any): ModuleWithProviders<EvictionIntakeModule> {
    return {
      ngModule: EvictionIntakeModule,
      providers: [
        { provide: 'environment', useValue: environment }
      ]
    };
  }
}
